import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.function.name.js";
import { computed, defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import POSConfigModule from "@/store/modules/pos-config";
import { dialogVisibleForStatus, hideDialog } from "@/utils/vue-helpers/modal";
import NotificationService from "@/services/notification.service";
import { ModalStatus } from "@/constants/modal";
import { fetchConfigPCs, fetchConfigPicture, fetchConfigTimeslots } from "@/utils/vue-helpers/pos-config";
import { LogLevel, LogService } from "@/services/logging";
import { getSalesConfigurationById } from "@/api/gql/sales-configurations";
import { toLocalPOSConfig } from "@/utils/helpers/pos-config";
import CommonModule from "@/store/modules/common";
import { fetchConfigSeatingPlanParentPCs, proceedFetchAndStoreGroupPicture } from "@/utils/helpers/product-category";
import { fetchNonReccuringSeatingPlanTimeslots } from "@/utils/helpers/timeslots";
import { pullAndStorePromocodeCampaigns } from "@/utils/vue-helpers/promocode";
import { loadOffers } from "@/utils/helpers/offers";
import { hasSalesStarted } from "@/utils/vue-helpers/cash-float";
import BookingModule from "@/store/modules/booking";
export default defineComponent({
  name: "ReloadConfiguration",
  setup: function setup() {
    console.log("hi from reloadConfig");

    var _useI18n = useI18n({}),
        t = _useI18n.t;

    var modalVisibility = dialogVisibleForStatus(ModalStatus.ReloadConfiguration); // const progressValue = ref<number>(0);

    var progressValue = computed(function () {
      var pcsProgress = POSConfigModule.pcsLoaded;
      var timeslotsProgress = POSConfigModule.timeslotsLoaded;

      if (pcsProgress > 50 || timeslotsProgress) {
        // We don't just keep growing the progress bar
        // we stop it at 60% then it will grow again when the app starts pulling timeslots
        pcsProgress = 50;
      }

      if (timeslotsProgress > 35) {
        // We don't keep growing the progress bar
        // we stop at 95 until timeslots are fully pulled
        timeslotsProgress = 35;
      }

      return 10 + pcsProgress + timeslotsProgress;
    }); // reload the current selected config

    function reloadConfig() {
      return _reloadConfig.apply(this, arguments);
    }

    function _reloadConfig() {
      _reloadConfig = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var selectedConfig, refreshedConfig, convertedConfig, hasSeatingPlanLogic;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return POSConfigModule.fetchGroupInfo();

              case 3:
                _context2.next = 8;
                break;

              case 5:
                _context2.prev = 5;
                _context2.t0 = _context2["catch"](0);
                LogService.info("Error while fetching Group Info", _context2.t0, LogLevel.Error);

              case 8:
                _context2.next = 10;
                return proceedFetchAndStoreGroupPicture();

              case 10:
                ////
                // progressValue.value = 5;
                // refresh the selected config data from backend as well
                selectedConfig = POSConfigModule.selectedConfig;

                if (selectedConfig) {
                  _context2.next = 14;
                  break;
                }

                // If no selected config then we don't reload
                LogService.info("There is no selected config to be reloaded", undefined, LogLevel.Error);
                return _context2.abrupt("return");

              case 14:
                _context2.prev = 14;
                _context2.next = 17;
                return getSalesConfigurationById(selectedConfig.id);

              case 17:
                refreshedConfig = _context2.sent;
                convertedConfig = toLocalPOSConfig(refreshedConfig[0]);
                POSConfigModule.SET_SELECTED_CONFIG(_objectSpread({}, convertedConfig)); // clear the selected grid

                POSConfigModule.selectGrid(null); // if user is allowed to sell through selected config => save POS config in localStorage

                if (!POSConfigModule.getPosConfigPermission) {
                  _context2.next = 43;
                  break;
                }

                _context2.next = 24;
                return fetchConfigPCs(convertedConfig);

              case 24:
                _context2.next = 26;
                return fetchConfigTimeslots(convertedConfig);

              case 26:
                // progressValue.value = 100;
                hasSeatingPlanLogic = CommonModule.hasSeatingPlanLogicEnabled;

                if (!hasSeatingPlanLogic) {
                  _context2.next = 32;
                  break;
                }

                _context2.next = 30;
                return fetchConfigSeatingPlanParentPCs();

              case 30:
                _context2.next = 32;
                return fetchNonReccuringSeatingPlanTimeslots();

              case 32:
                _context2.prev = 32;
                _context2.next = 35;
                return loadOffers();

              case 35:
                LogService.info("Offers object instantiated");
                _context2.next = 41;
                break;

              case 38:
                _context2.prev = 38;
                _context2.t1 = _context2["catch"](32);
                LogService.info("Failed to instantiate offers object", {
                  error: _context2.t1
                });

              case 41:
                _context2.next = 45;
                break;

              case 43:
                // user is not allowed to sell using selected config => remove POS config and show error notification
                POSConfigModule.removePOSConfig();
                NotificationService.showPosConfigurationError(convertedConfig.name);

              case 45:
                _context2.next = 47;
                return pullAndStorePromocodeCampaigns();

              case 47:
                _context2.next = 49;
                return fetchConfigPicture(convertedConfig.id);

              case 49:
                setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          // It is sure that every data from remote to start selling is now pulled and stored in local db
                          // lets create a new booking if sales has already started
                          if (hasSalesStarted.value) {
                            console.log("******** calling BookingModule.createNewBooking");
                            BookingModule.createNewBooking();
                          }

                          hideDialog();
                          POSConfigModule.setPCsLoaded(0);
                          POSConfigModule.setTimeslotsLoaded(0);

                        case 4:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                })), 500);
                _context2.next = 57;
                break;

              case 52:
                _context2.prev = 52;
                _context2.t2 = _context2["catch"](14);
                hideDialog();
                LogService.info("Error while refetching selected config", _context2.t2, LogLevel.Error);
                NotificationService.showGeneralResponseError();

              case 57:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 5], [14, 52], [32, 38]]);
      }));
      return _reloadConfig.apply(this, arguments);
    }

    return {
      t: t,
      modalVisibility: modalVisibility,
      progressValue: progressValue,
      reloadConfig: reloadConfig
    };
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var selectedConfig;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              // refresh the selected config data from backend as well
              selectedConfig = POSConfigModule.selectedConfig;

              if (!selectedConfig) {
                // If no selected config then we don't reload
                LogService.info("There is no selected config to be reloaded", undefined, LogLevel.Error);
                hideDialog();
              } else {
                _this.reloadConfig();
              }

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  }
});